function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "341.334,85.33 170.666,85.33 0,85.33 0,426.662 170.666,426.662 341.334,426.662  512,426.662 512,85.33 "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85.333,
    style: {
      fill: "#6DA544"
    },
    width: 170.663,
    height: 341.337
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.337,
    y: 85.333,
    style: {
      fill: "#D80027"
    },
    width: 170.663,
    height: 341.337
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalian);
export default __webpack_public_path__ + "static/media/italian.f168bbe8c252425c51999cc2a4a12cb4.svg";
export { ForwardRef as ReactComponent };